<ez-selectable-card [cardTitle]="policy().lob"
                    [selected]="selected()"
                    [radioMode]="radioMode()"
                    (selectedChange)="selectedChange.emit($event)">
  <div class="surface column dense">
    <div class="row policy-number-row">
      <b>{{ policy().policyNumber }}</b>
      <ez-chip [color]="chipColor()">{{ policy().policyStatus }}</ez-chip>
    </div>
    <span class="mat-caption text-light">{{ policy().carrierName }}</span>
    <div class="row date-range mat-caption text-light">
      <mat-icon small
                class="decorative-color">calendar_today</mat-icon>
      <span>{{ policy().effectiveDate | date: 'MMM d, yyyy' }}</span>
      <mat-icon small
                class="decorative-color">arrow_forward</mat-icon>
      <span>{{ policy().expirationDate | date: 'MMM d, yyyy' }}</span>
    </div>
  </div>
</ez-selectable-card>